import { useCallback } from 'react';

import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { ErrorMessage, KiloGLMFlow, KiloGLMFlowWrite } from 'types';
import { client } from 'utils/api-client';

export default function useUpdateKiloGLMFlow(): UseMutationResult<
  AxiosResponse<KiloGLMFlow>,
  AxiosError<ErrorMessage>,
  KiloGLMFlowWrite
> {
  const queryClient = useQueryClient();

  const updateKiloGLMFlow = useCallback(
    (kiloGLMFlow: KiloGLMFlowWrite): Promise<AxiosResponse<KiloGLMFlow>> => {
      return client.put(`kilo-glm-flows/${kiloGLMFlow.kiloGlmFlowId}/`, kiloGLMFlow);
    },
    [],
  );

  return useMutation(updateKiloGLMFlow, {
    onSuccess: () => {
      queryClient.invalidateQueries('kilo-glm-flows');
    },
  });
}
